import Immutable from 'immutable'

export const HmacRecord = Immutable.Record({
  data: null,
  expires: null, // Dont convert to moment, this is used as is in auth headers
  hmac: null,
  user: '',
}, 'HMAC')

export default function createHmac(data) {
  return new HmacRecord(data)
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Hmac.js